export const jsonLocal =
{
    "mtServiceUrl": "http://localhost:5004",
    "GoogleApiWrapper": "AIzaSyBpirc3QTYyZ4M8bpx0QfWTyvPtoYELXtM"
};
  